import HttpClient from './httpClient';
import { getGlobal } from '../../global';

const global = getGlobal();
const currentUserId = global.currentUserId;

export const apiClient = new HttpClient({
  baseURL: process.env.WORKSPACE_API_URL || '',
  headers: {
    ...(currentUserId && { 'x-user-id': currentUserId }),
  },
});

